import React, { useRef, useEffect, useState } from 'react';

const Mission = () => {
    const componentRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const currentRef = componentRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.2 }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <section ref={componentRef} className={`premium-spirit-section ${isVisible ? 'animate-in' : ''}`}>
            <div className="spirit-card">
                
                {/* Left Side: Mission */}
                <div className="spirit-content mission-side">
                    <h2 className="spirit-title">Our Mission</h2>
                    <p className="spirit-desc">
                        To create, preserve and promote Value Awareness among youth through systematic education 
                        and training. We aim for holistic growth that heralds a constructive transformation 
                        of hearts, ensuring sustainable peace and happiness worldwide.
                    </p>
                </div>

                {/* The Central Animation (The Divider) */}
                <div className="spirit-divider-container">
                    <div className="glowing-line top"></div>
                    <div className="center-mechanism">
                        <div className="orbit-circle"></div>
                        <div className="core-star"></div>
                    </div>
                    <div className="glowing-line bottom"></div>
                </div>

                {/* Right Side: Vision */}
                <div className="spirit-content vision-side">
                    <h2 className="spirit-title">Our Vision</h2>
                    <p className="spirit-desc">
                        To make youth thoughtful towards the importance of values in daily life. 
                        We inspire them to become perfect leaders by inculcating ethics, 
                        creating a better India and becoming true assets to the nation.
                    </p>
                </div>

            </div>
        </section>
    );
};

export default Mission;